<script>
export default {
  data() {
    return {
      input: null,
      value: null
    };
  },

  mounted() {
    this.input = this.$el.querySelectorAll("input, textarea")[0];
    this.setValue();
  },

  methods: {
    setValue() {
      this.value = this.input.value;
    }
  },

  computed: {
    words() {
      if (!this.value) {
        return 0;
      }

      return this.value.split(" ").filter(word => word != "").length;
    }
  },

  render() {
    return this.$scopedSlots.default({
      words: this.words,
      update: () => {
        this.setValue();
      }
    });
  }
};
</script>
